import * as React from "react";
import { ShowClientError } from "source/app/presentation/Shared/ErrorBoundary";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";
import { IsProduction } from "source/app/services/External/Environment/Environment";

export function ClientErrorScreenDevelopmentControl() {
    const [isEnabled, setIsEnabled] = React.useState(false);

    if (IsProduction()) {
        return null;
    }

    return (
        <div
            className={StyleClassAuto({
                margin: "10px 0",
                fontSize: "12px",
                opacity: 0.82,
            })}
        >
            <label
                className={StyleClassAuto({
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    cursor: "pointer",
                    userSelect: "none",
                })}
            >
                <input
                    type="checkbox"
                    checked={isEnabled}
                    onChange={(event) => {
                        const enabled = event.target.checked;
                        setIsEnabled(enabled);

                        if (enabled) {
                            ShowClientError(CreateAuthorizationError());
                        }
                    }}
                />
                Show authorization error screen
            </label>
            <div className={StyleClassAuto({ marginTop: "6px", opacity: 0.72 })}>
                Simulates a 401 auth-cookie failure
            </div>
        </div>
    );
}

function CreateAuthorizationError() {
    const error = new Error("Request failed with status code 401");

    Object.assign(error, {
        response: {
            status: 401,
            data: "No cookies found. Please login again.",
        },
    });

    return error;
}
